import { AnchorTarget } from '../_types/anchor-target.ts';
import { MouseEvent, useState } from 'react';
import './AlertBar.scss';

export type AlertBarProps = {
	title: string;
	desktopLabel: string;
	mobileLabel?: string;
	ariaLabel: string;
	target: AnchorTarget;
	url: string;
	dataLinkEvent: string;
	rel: string;
	closed?: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const AlertBar: React.FC<AlertBarProps> = (props) => {
	const [removed, setRemoved] = useState<boolean>(false);

	const onCloseButtonClicked = (event: MouseEvent) => {
		event.stopPropagation();
		props.closed?.();
		setRemoved(true);
	};

	return (
		!removed &&
		props.desktopLabel && (
			<div className="blk-ac-alert-bar" title={props.title}>
				<div className="blk-ac-container-fluid">
					<div className="blk-ac-row">
						<div className="blk-ac-col">
							<div className="blk-ac-alert-label-container">
								<i className="fa fa-bell-o" aria-hidden="true"></i>
								<a
									href={props.url}
									aria-label={props.ariaLabel || ''}
									target={props.target || '_self'}
									rel={props.rel}
									data-link={props.dataLinkEvent}
									className="blk-ac-link-subdued-secondary blk-ac-alert-link blk-ac-body-m-bold"
									data-final-url
								>
									<span className="label-for-desktop">
										{props.desktopLabel}
									</span>
									<span className="label-for-mobile">
										{props.mobileLabel || props.desktopLabel}
									</span>
								</a>
							</div>
							<button
								className="blk-ac-alert-close"
								aria-label="Close alert bar"
								onClick={onCloseButtonClicked}
							>
								<i className="fa fa-close" aria-hidden="true"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	);
};

export default AlertBar;
